import { SolutionType } from '../solutionType';
const SolutionTypeBySampleID = {
    sampleGenderPay: SolutionType.GenderPayGap,
    sampleDiversity: SolutionType.Diversity,
    sampleCustomerChurn: SolutionType.Churn,
    sampleSellerChurn: SolutionType.SellerChurn,
    sampleSellerPerformance: SolutionType.SellerPerformance,
    sampleBenchmarking: SolutionType.Benchmarking
};
export const getSampleSolutionTypeFromID = (solutionID) => {
    return SolutionTypeBySampleID[solutionID];
};
export const SampleSolutionSolutionIDMap = {
    [SolutionType.GenderPayGap]: 'sampleGenderPay',
    [SolutionType.Diversity]: 'sampleDiversity',
    [SolutionType.Churn]: 'sampleCustomerChurn',
    [SolutionType.SellerChurn]: 'sampleSellerChurn',
    [SolutionType.SellerPerformance]: 'sampleSellerPerformance',
    [SolutionType.Benchmarking]: 'sampleBenchmarking'
};
export const ReverseSampleSolutionSolutionIDMap = Object.keys(SampleSolutionSolutionIDMap).reduce((ret, key) => {
    // eslint-disable-next-line no-param-reassign
    ret[SampleSolutionSolutionIDMap[key]] = key;
    return ret;
}, {});
export const SampleSolutionPipeIDMap = {
    [SolutionType.GenderPayGap]: 'sample_GPG5S4g',
    [SolutionType.Diversity]: 'sample_DIV554g',
    [SolutionType.Churn]: 'sample_CCq554g',
    [SolutionType.SellerChurn]: 'sample_SCq1q4w',
    [SolutionType.SellerPerformance]: 'sample_SPeq12Q',
    [SolutionType.Benchmarking]: 'sample_BM3agiQ'
};
export const ReverseSampleSolutionPipeIDMap = Object.keys(SampleSolutionPipeIDMap).reduce((ret, key) => {
    // eslint-disable-next-line no-param-reassign
    ret[SampleSolutionPipeIDMap[key]] = key;
    return ret;
}, {});
export const SamplePipeIDs = Array.from(Object.values(SampleSolutionPipeIDMap));
//# sourceMappingURL=solutionHelper.js.map